import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Page/page';
import { css } from '@patternfly/react-styles';
import { PageContextConsumer } from './Page';
export var PageSidebar = function PageSidebar(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      nav = _a.nav,
      _a$isNavOpen = _a.isNavOpen,
      isNavOpen = _a$isNavOpen === void 0 ? true : _a$isNavOpen,
      _a$theme = _a.theme,
      theme = _a$theme === void 0 ? 'dark' : _a$theme,
      props = __rest(_a, ["className", "nav", "isNavOpen", "theme"]);

  return React.createElement(PageContextConsumer, null, function (_ref) {
    var isManagedSidebar = _ref.isManagedSidebar,
        managedIsNavOpen = _ref.isNavOpen;
    var navOpen = isManagedSidebar ? managedIsNavOpen : isNavOpen;
    return React.createElement("div", Object.assign({
      id: "page-sidebar",
      className: css(styles.pageSidebar, theme === 'light' && styles.modifiers.light, navOpen && styles.modifiers.expanded, !navOpen && styles.modifiers.collapsed, className)
    }, props), React.createElement("div", {
      className: css(styles.pageSidebarBody)
    }, nav));
  });
};